import mainLogo from '../../images/Akta/akta_black.png';
import squareLogo from '../../images/Akta/akta_black_square.png';
import bannerLogoWhite from '../../images/Akta/akta_white.png';
import banner01 from '../../images/Akta/akta_bannerbg_01_01.jpg';
import banner02 from '../../images/Akta/akta_bannerbg_01_03.jpg';
import banner03 from '../../images/Akta/akta_bannerbg_01_02.jpg';
import banner04 from '../../images/Akta/akta_bannerbg_02_01.jpg';
import car123 from '../../images/Akta/123_basalt.jpg';
import box123 from '../../images/Akta/123_akta.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Akta',
    defaultStoreLink: 'aktapecas.com.br"',
    defaultContactEmail: 'aktapecas@aktamotors.com.br',
    whatsappNumber: '11 99451 1162',
    CNPJname: 'Akta Motors Distribuidora de Veiculos LTDA',
    CNPJ: '12.911.519/0003-72',
    CNPJaddress: 'Av. Dr. Gastão Vidigal, 1082 - Vila Leopoldina, São Paulo - SP, 05314-000',
    launchDate: '18/02/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "citroen",
        "kia",
        "peugeot",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "SAINT-TROPEZ PEUGEOT SANTOS",
        "AKTA KIA",
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerImg01: bannerLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    banner04: banner04,
    bannerBrands: '',
    aboutUsBg: banner04,

    box123: box123,
    car123: car123,
    
    paymentImg: mainLogo,
    paymentImgMobile: mainLogo,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais compatíveis com <span style="font-weight: bold;">seu veículo</span>, direto das concessionárias <span style="font-weight: bold;">Akta</span>.',
    aboutUs: {
        title: 'Quem somos',
        content: [
            'O Grupo Akta, fundado em 2011 em Osasco por Gustavo Gotfryd, é uma referência no setor automotivo, representando marcas como Kia, Peugeot e Citroën. Com mais de 25.000 veículos vendidos, o Grupo também atua na revenda multimarcas através da Akta Imports e oferece serviços de blindagem veicular com a Bélico Blindagem, homologada pelo Exército Brasileiro. Além disso, o Grupo expandiu suas operações com a Akta Fleet, oferecendo locação de veículos por assinatura. Com raízes em Santos, o Grupo Akta orgulha-se de sua credibilidade e compromisso com a excelência.',
        ],
        link: 'https://umuaramaconcessionarias.com.br/quem-somos/',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/aktamotors/',
        Facebook: 'https://www.facebook.com/AktaMotors',
        LinkedIn: 'https://www.linkedin.com/company/grupo-akta-motors/?viewAsMember=true',
        Youtube: 'https://www.youtube.com/c/GrupoAktaMotors/videos',
        Twitter: '',
    },

    footerContent: [],
}